import React from 'react';
import PropTypes from 'prop-types';

import {Grid, Stack, Button, Box, CircularProgress, Typography} from 'views/components';
import {Translate} from 'views/module';

import MessageFeedBox from './MessageFeedBox';

const MessageFeed = (props) => {
  const {
    jobRn,
    jobMessages,
    jobMessagesLoading,
    jobMessagesLastEvaluatedKey,
    sortDir,
    messageTypeFilter,
    jobBackend,
  } = props;

  const loadMoreMessages = () => {
    if (jobMessagesLastEvaluatedKey && !jobMessagesLoading) {
      jobBackend.load.loadMessages(jobRn, jobMessagesLastEvaluatedKey);
    }
  };

  const messagesToDisplay = React.useMemo(() => {
    return Object.values(jobMessages)
        .filter((message) => messageTypeFilter[message.messageType])
        .sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);

          if (sortDir === 'DESC') {
            return dateB - dateA;
          }

          return dateA - dateB;
        });
  }, [jobMessages, messageTypeFilter, sortDir]);

  const showLoadMoreButton = jobMessagesLastEvaluatedKey && !jobMessagesLoading;

  return (
    <Grid container>
      <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 1 : 2}}>
        <Stack
          sx={{
            pt: 1,
            pb: 2,
          }}
        >
          {
            messagesToDisplay.length === 0 && !jobMessagesLoading &&
            <Box px={2} py={1}>
              <Typography color="text.secondary" align="center">
                <Translate expression="career.jobDetail.Messages.Empty" />
              </Typography>
            </Box>
          }
          {
            messagesToDisplay.map((message) => (
              <Box key={message.messageRn}>
                <MessageFeedBox
                  message={message}
                  jobBackend={jobBackend}
                />
              </Box>
            ))
          }
        </Stack>
      </Grid>
      {
        jobMessagesLoading &&
        <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
          <CircularProgress/>
        </Grid>
      }
      {
        showLoadMoreButton &&
        <Grid item xs={12} order={{xs: sortDir === 'DESC' ? 2 : 1}} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            color={'primary'}
            onClick={loadMoreMessages}
          >
            <Translate expression={'career.jobDetail.Messages.LoadMore'} />
          </Button>
        </Grid>
      }
    </Grid>
  );
};

MessageFeed.propTypes = {
  jobRn: PropTypes.string.isRequired,
  jobMessages: PropTypes.object.isRequired,
  jobMessagesLoading: PropTypes.bool.isRequired,
  jobMessagesLastEvaluatedKey: PropTypes.string,
  sortDir: PropTypes.string.isRequired,
  messageTypeFilter: PropTypes.shape({
    ANNOUNCEMENTS: PropTypes.bool.isRequired,
    COMMENTS: PropTypes.bool.isRequired,
  }).isRequired,
  jobBackend: PropTypes.object.isRequired,
};

export default React.memo(MessageFeed);
